"use client"

import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import type { AppDispatch, RootState } from './store';

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = () => useDispatch<AppDispatch>();

/**
 * Default to shallowEqual so selectors that return a new object/array literal
 * with the same contents (common in this codebase) do not infinite-loop under
 * React useSyncExternalStore during SSR / hydration.
 *
 * Pass `(a, b) => a === b` only when you intentionally need reference equality.
 */
export function useAppSelector<TSelected>(
  selector: (state: RootState) => TSelected,
  equalityFn: (left: TSelected, right: TSelected) => boolean = shallowEqual,
): TSelected {
  return useSelector(selector, equalityFn);
}
